<template>
    <div class="row">
        <div class="col-12 mb-1">Çalışma Gün Türü: {{ value.EmployeeWorkingTypeName }} <b>({{ value.EmployeeWorkingTypeCode }})</b></div>
        <div class="col-12">
            <label class="form-label">Luca Kodu</label>
            <input class="form-control" v-model="value.LucaCode" placeholder="Luca Kodu">
        </div>
    </div>
</template>

<script>
export default{
    props:{
        value:Object
    }
}
</script>